import {
  Text,
  Colors,
  Media,
  Spacing,
  StackChildren,
  Inset,
} from '@doordash/design-language'
import styled from 'styled-components'

import { COLOR_PINK_BGC, LANDING as Style, LANDING_CONTENT } from './constants'
import { AWS_BASE } from '../../../constants'

const PAYOUT_IMG = `${AWS_BASE}/img/dasher/payout.png`

export const FormContainer = styled.div`
  position: absolute;
  top: auto;
  height: ${Style.FORM_CONTAINER.HEIGHT};
  right: 50%;
  transform: translate(50%, -120%);
  z-index: 10;
  min-width: ${Style.FORM_CONTAINER.MIN_WIDTH};

  ${Media.Mobile`
    height: auto;
    margin: ${Spacing.Large}px auto 0;
    position: inherit;
    display: flex;
    justify-content: center;
    transform: translateY(-18%);
    min-width: ${Style.FORM_CONTAINER.MOBILE.MIN_WIDTH};
    margin: ${Spacing.Large}px;
    padding: 0;
  `}
`
export const SlideFormContainer = styled(Inset)`
  display: flex;
  align-items: center;

  ${Media.Tablet`
    padding: ${Inset.Sizes.Medium}px;
    width: 100%;
  `}
  ${Media.Mobile`
    padding: ${Inset.Sizes.Small}px;
  `}
`

export const LandingContent = styled.div`
  height: 100%;
  max-width: ${LANDING_CONTENT.MAX_WIDTH};
  margin: 0 auto;

  ${Media.Mobile`
    background-color: ${COLOR_PINK_BGC};
  `}
`

// tslint:disable:max-line-length
export const ValuePropsWrapper = styled.div`
  padding: 0 ${Spacing.Small}px ${Spacing.XxxLarge}px ${Spacing.Small}px;
  margin-top: ${Spacing.XxLarge}px;

  ${Media.Mobile`
    background-color: ${Colors.SystemWhite};
    background-repeat: no-repeat;
    background-position: cover;
    background-size: contain;

    padding: ${Spacing.XxLarge}px ${Spacing.Small}px ${Spacing.XxxLarge}px ${Spacing.Small}px;
    margin: 0;
  `}
`

export const FaqContainer = styled.div.attrs({
  role: 'radiogroup',
})`
  max-width: 768px;
  margin: 0 auto;
  padding-bottom: ${Spacing.XLarge}px;

  ${Media.Mobile`
    margin: ${Spacing.Large}px;
  `}
`

export const FAQTitle = styled(Text)`
  /* important needed to override margin from h2 */
  margin-top: ${Spacing.XxLarge}px !important;
  text-align: center;
  font-size: 36px;
`

export const CellWrapper = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
`

export const RenderBefore = styled.div`
  &:after {
    content: '';

    position: absolute;
    left: 0;
    top: 0;

    width: 7px;
    height: 100%;
  }
`

export const WhatIsDoorDashWrapper = styled.div`
  align-content: center;
  display: flex;
  background-color: ${Colors.SystemGrey0};
  margin: 0 auto;
  padding: ${Spacing.XLarge}px 0 ${Spacing.XLarge}px 0;
`

export const SignUpDetailsWrapper = styled.div`
  align-content: center;
  display: flex;
  background-color: ${Colors.SystemRed5};
  margin: 0 auto;
  padding: ${Spacing.XxLarge}px 0 ${Spacing.XxLarge}px 0;
`

export const HowToDashTitle = styled(Text)`
  margin-top: ${Spacing.XxLarge}px !important;
  text-align: center;
  font-size: 36px;
`

export const HowToDashContainer = styled(StackChildren)`
  padding-top: ${Spacing.Small}px;
  background-color: ${Colors.SystemWhite};
`
export const HeroContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  ${Media.Mobile`
    height: 80vh;
  `}
`

export const HeroImage = styled.div`
  width: 40%;
  background: url(${PAYOUT_IMG}) no-repeat;
  background-size: 328px auto;
  background-position: center calc(50% + 60px);
  background-color: ${Colors.SystemRed0};

  ${Media.Tablet`
    display: none;
  `}
`
